import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  return <section className="w-full bg-[#f5f5f5] py-8 md:py-16 px-4" data-id="element-253">
      <div className="max-w-7xl mx-auto" data-id="element-254">
        <h2 className="text-2xl md:text-5xl lg:text-6xl font-black text-gray-900 text-center mb-4 md:mb-6" data-id="element-255">
          Barberos que ya aplican{' '}
          <span className="text-[#c41e3a]" data-id="element-256">el método</span>
        </h2>
        <div className="w-20 md:w-32 h-1 bg-[#c41e3a] mx-auto mb-8 md:mb-14" data-id="element-257"></div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-10" data-id="element-258">
          <div className="bg-white rounded-lg p-5 md:p-10 shadow-lg border-4 border-gray-300" data-id="element-259">
            <QuoteIcon className="w-8 h-8 md:w-12 md:h-12 text-[#c41e3a] mb-4" aria-hidden="true" data-id="element-260" />
            <p className="text-gray-700 text-base md:text-xl leading-relaxed mb-4" data-id="element-261">
              "Ahora entiendo por qué hago cada corte. Uso el ebook como guía
              todos los días."
            </p>
            <p className="text-gray-900 font-black text-sm md:text-base" data-id="element-262">
              Lucas M. – Buenos Aires
            </p>
          </div>

          <div className="bg-white rounded-lg p-5 md:p-10 shadow-lg border-4 border-gray-300" data-id="element-263">
            <QuoteIcon className="w-8 h-8 md:w-12 md:h-12 text-[#c41e3a] mb-4" aria-hidden="true" data-id="element-264" />
            <p className="text-gray-700 text-base md:text-xl leading-relaxed mb-4" data-id="element-265">
              "Dejé de improvisar. El método te ordena la cabeza y el trabajo."
            </p>
            <p className="text-gray-900 font-black text-sm md:text-base" data-id="element-266">
              Matías R. – Córdoba Capital
            </p>
          </div>

          <div className="bg-white rounded-lg p-5 md:p-10 shadow-lg border-4 border-gray-300" data-id="element-267">
            <QuoteIcon className="w-8 h-8 md:w-12 md:h-12 text-[#c41e3a] mb-4" aria-hidden="true" data-id="element-268" />
            <p className="text-gray-700 text-base md:text-xl leading-relaxed mb-4" data-id="element-269">
              "No es un curso más. Es una formación bien pensada."
            </p>
            <p className="text-gray-900 font-black text-sm md:text-base" data-id="element-270">
              Nicolás G. – Rosario
            </p>
          </div>

          <div className="bg-white rounded-lg p-5 md:p-10 shadow-lg border-4 border-gray-300" data-id="element-271">
            <QuoteIcon className="w-8 h-8 md:w-12 md:h-12 text-[#c41e3a] mb-4" aria-hidden="true" data-id="element-272" />
            <p className="text-gray-700 text-base md:text-xl leading-relaxed mb-4" data-id="element-273">
              "Me ayudó a profesionalizarme y a cobrar mejor mis servicios."
            </p>
            <p className="text-gray-900 font-black text-sm md:text-base" data-id="element-274">
              Franco D. – La Plata
            </p>
          </div>
        </div>
      </div>
    </section>;
}